import React from 'react'
import CommonMomentAndAttendance from '../commonfile/CommonMomentAndAttendance'

const ApartmentMomentAtd = () => {

    return (
        <>

            <CommonMomentAndAttendance />
        </>
    )
}

export default ApartmentMomentAtd